export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 64

export interface IPasswordRule {
    id: string
    labelKey: string
    check: (password: string) => boolean
}

export const PASSWORD_RULES: IPasswordRule[] = [
    { id: 'minLength', labelKey: 'passwordPolicy.minLength', check: password => password.length >= PASSWORD_MIN_LENGTH },
    { id: 'maxLength', labelKey: 'passwordPolicy.maxLength', check: password => password.length <= PASSWORD_MAX_LENGTH },
    { id: 'uppercase', labelKey: 'passwordPolicy.uppercase', check: password => /[A-Z]/.test(password) },
    { id: 'lowercase', labelKey: 'passwordPolicy.lowercase', check: password => /[a-z]/.test(password) },
    { id: 'number', labelKey: 'passwordPolicy.number', check: password => /[0-9]/.test(password) },
    // eslint-disable-next-line no-restricted-syntax -- 한글은 특수문자로 세지 않는다
    { id: 'special', labelKey: 'passwordPolicy.special', check: password => /[^A-Za-z0-9\s가-힣]/.test(password) },
    { id: 'whitespace', labelKey: 'passwordPolicy.whitespace', check: password => !/\s/.test(password) }
]

export const isPasswordValid = (password: string) => (
    password.length > 0 && PASSWORD_RULES.every(rule => rule.check(password))
)
